module.exports = __webpack_public_path__ + "img/project1_6.png.a9449cf3.webp";